import { Dialog, DialogFooter, DialogText, FailedCallout, ReasonField, useReason, useToast } from "@amber/ui";
import { relationChangeResponseSchema } from "../../contracts/index";
import { EVIDENCE_ERROR_FALLBACK, REQUIRED_REASON } from "../format";
import { useEvidenceCommand } from "../queries";

export function ReverseRelationDialog({
  itemId,
  relationId,
  onClose,
}: {
  itemId: string;
  relationId: string;
  onClose: () => void;
}) {
  const toast = useToast();
  const reason = useReason(null, REQUIRED_REASON);
  const save = useEvidenceCommand(itemId, relationChangeResponseSchema);
  return (
    <Dialog
      open
      onOpenChange={(open) => {
        if (!open) onClose();
      }}
      title="Reverse…"
      onSubmit={() => {
        if (reason.submit())
          save.mutate(
            { path: `/api/evidence/relations/${relationId}/reverse`, body: { reason: reason.trimmed } },
            {
              onSuccess: (out) => {
                toast.show(out.message);
                onClose();
              },
            },
          );
      }}
      footer={<DialogFooter onClose={onClose} confirm="Reverse" pending={save.isPending} />}
    >
      <DialogText>
        Restores the communications as they were before. Both keep their IDs, so old links keep working; readers and
        exports receive a relationship notice. Corrections made since stay with the passages they changed.
      </DialogText>
      <ReasonField value={reason.reason} onChange={reason.setReason} error={reason.error} />
      <FailedCallout error={save.error} fallback={EVIDENCE_ERROR_FALLBACK} />
    </Dialog>
  );
}
